import { camelizedJSONFetch as camelizedJSONFetch$1, legacyFetch as legacyFetch$1 } from "@squareup/util-api-client";
import { DashboardQueryContext } from "../context.js";
const legacyFetch = async (...args) => {
  const [resource, options] = args;
  const { baseUrl } = DashboardQueryContext;
  if (baseUrl && typeof resource === "string" && !resource.startsWith("http")) {
    const url = new URL(resource, baseUrl);
    return legacyFetch$1(url.toString(), options);
  }
  return legacyFetch$1(resource, options);
};
const camelizedJSONFetch = async (...args) => {
  const [resource, options] = args;
  const { baseUrl } = DashboardQueryContext;
  if (baseUrl && typeof resource === "string" && !resource.startsWith("http")) {
    const url = new URL(resource, baseUrl);
    return camelizedJSONFetch$1(url.toString(), options);
  }
  return camelizedJSONFetch$1(resource, options);
};
export {
  camelizedJSONFetch,
  legacyFetch
};
//# sourceMappingURL=fetchShim.js.map
